export default {
    availableLocales: [ 'en', 'nl' ],
    defaultLocale: 'en'
};